import { apiFetch } from "./CommonApi";
import { notify } from "../Components/Common";

export const getOrderSettings = () => {
  return apiFetch("GET", "service/order-settings/", null, true).then((res) => {
    if (res.ok) {
      return res.json();
    }
    notify("error", "Failed to load order settings");
  });
};

export const saveOrderSettings = (body) => {
  return apiFetch("POST", "service/order-settings/", body, true)
    .then((res) => {
      if (res.ok) {
        notify("success", "Order settings saved");
        return res.json();
      }
      throw new Error("Failed to save order settings");
    })
    .catch((error) => {
      console.error("Error", error);
      notify("error", "Failed to save order settings");
      throw error;
    });
};
